import { Component } from 'react';
import { inject, observer } from 'mobx-react';

@inject(stores => ({ model: stores.liveClassModel }))
@observer
class LiveClassConsumer extends Component {
  render() {
    const { children, model } = this.props;
    return children({ model });
  }
}

const withLiveClassModel = inject('liveClassModel');

export { LiveClassConsumer, withLiveClassModel };
